import React, { useState } from 'react';

import getExportJobStatus from './utils/getExportJobStatus';
import filterGradesWithErrors from './utils/filterGradesWithErrors';
import filterStudentsGrades from './utils/filterStudentsGrades';
import { LastJob } from '$variables/types';
import Modal from '$components/Modal';
import Grades from '$components/Grades';

import { ExportStatusTitle, ModalContent } from './ExportGradesStatus.styled';

const ExportGradesStatus = ({ exportJob }) => {
  if (!exportJob) return null;

  const { status, updatedAt, lastEvent, grades, overrides } = exportJob;

  const [errorsModalOpen, setErrorsModalOpen] = useState(false);

  const handleErrorModalOpen = () => {
    setErrorsModalOpen(true);
  };

  const handleErrorModalClose = () => {
    setErrorsModalOpen(false);
  };

  const {
    message,
    isJobFailed,
    hasStudentErrors,
    successfulExports,
    studentErrors,
  } = getExportJobStatus({
    status,
    updatedAt,
    event: lastEvent,
    grades,
  });

  if (!message) return null;

  const errors = filterGradesWithErrors({
    grades,
    errors: studentErrors,
    hasStudentErrors,
    isJobFailed,
    overrides,
  });

  const { exported, notExported } = filterStudentsGrades({
    grades,
    overrides,
    successfulExports,
  });

  return (
    <>
      <ExportStatusTitle
        aria-label="last exported date"
        isFailed={isJobFailed}
        onClick={handleErrorModalOpen}
      >
        {message}
      </ExportStatusTitle>
      <Modal
        open={errorsModalOpen}
        handleClose={handleErrorModalClose}
        headerText="Export status"
      >
        <ModalContent>
          {errors.length > 0 && (
            <Grades
              key="export-errors"
              isLoading={false}
              disableAvatar
              disableInfoTag
              grades={errors}
              headerText="Export errors"
              isClickable={false}
            />
          )}
          {notExported.length > 0 && (
            <Grades
              key="no-grade-exports"
              isLoading={false}
              disableAvatar
              disableInfoTag
              grades={notExported}
              headerText="Not exported"
              isClickable={false}
            />
          )}
          {exported.length > 0 && (
            <Grades
              key="successful-exports"
              isLoading={false}
              disableAvatar
              disableInfoTag
              grades={exported}
              headerText="Successfully exported"
              isClickable={false}
            />
          )}
        </ModalContent>
      </Modal>
    </>
  );
};

ExportGradesStatus.propTypes = {
  exportJob: LastJob,
};

ExportGradesStatus.defaultProps = {
  exportJob: undefined,
};

export default ExportGradesStatus;
